import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import LandingPage from "./pages/LandingPage";
import PrivacyPage from "./pages/PrivacyPolicy";
import PrivacyModal from "./components/PrivacyModal";
import { Toaster } from "./components/ui/sonner";

function App() {
  const [showPrivacy, setShowPrivacy] = useState(false);

  useEffect(() => {
    // open popup if URL has #privacy-policy
    if (window.location.hash === "#privacy-policy") {
      setShowPrivacy(true);
    }

    const handleHashChange = () => {
      if (window.location.hash === "#privacy-policy") {
        setShowPrivacy(true);
      }
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  const closePrivacy = () => {
    setShowPrivacy(false);
    window.history.replaceState(null, "", window.location.pathname);
  };

  const allowedPaths = [
    "consult-now",
    "book-now",
    "call-now",
    "talk-now",
    "get-help-now",
    "start-consultation",

    "love-problem",
    "get-ex-love-back",
    "relationship-solution",

    "remove-negative-energy",
    "black-magic-removal",
    "spiritual-protection",

    "marriage-problem",
    "husband-wife-dispute",
    "divorce-solution",

    "vedic-astrology",
    "online-astrology-consultation",
    "horoscope-reading",

    "lottery-prediction",
    "future-prediction",
    "lucky-number",

    "astrologer-in-usa",
    "astrologer-in-uk",
    "astrologer-in-canada",
  ];

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          
          {allowedPaths.map((path) => (
            <Route key={path} path={`/${path}`} element={<LandingPage />} />
          ))}

          {/* block other URLs */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>

      {/* Privacy Modal */}
      <PrivacyModal isOpen={showPrivacy} onClose={closePrivacy} />

      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
